module.exports = __webpack_public_path__ + "static/img/大暴雨转特大暴雨.5b4dea90.svg";